"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateApprovalFrontendForm = exports.approvalFrontendSchema = void 0;
// Arrears Approval - Front End Schema Validator
var schema_validator_1 = require("@hobt/schema-validator");
var approval_1 = require("../approval");
exports.approvalFrontendSchema = {
    type: 'object',
    // additionalProperties: {
    //   not: true,
    //   /* eslint-disable-next-line no-template-curly-in-string */
    //   errorMessage: '- should not have additional property ${0#}',
    // },
    required: ['approverReview'],
    properties: {
        approverReview: approval_1.approverReviewFrontendSchema,
        attachments: {
            type: ['array', 'null'],
            items: approval_1.approvalAttachmentFrontendSchema,
            errorMessage: 'Should be an array of ApprovalAttachments or null',
        },
    },
};
exports.validateApprovalFrontendForm = function (approvalForm) {
    var arrearsFormValidator = new schema_validator_1.SchemaValidator(exports.approvalFrontendSchema, true, false, true, true);
    return arrearsFormValidator.validate(approvalForm);
};
